<template>
  <div class="cctv">
    <el-card class="ccctv-card">
      <div slot="header"
           class="clearfix">
        <span>视频监控</span>
      </div>
      <div class="video-list">
        <ul>
          <li :class="index === currentIndex? 'active' : ''" v-for="(i, index) in videos" :key="index" @click="selVideo(i.id, index)">
            {{i.typeName}}
          </li>
        </ul>
      </div>
    </el-card>
    <div class="videos" v-if="selectVideo">
      <div class="video-title">
        <span>{{selectVideo.name}}</span>
      </div>
      <div class="monitor">
        <iframe :src="videoSrc" frameborder="0"></iframe>
          <!-- <video class="h5video" id='h5sVideoid' style="width:100%;height:100%"></video> -->
      </div>
      <span class="l-btn" @click="leftChange"></span>
      <span class="r-btn" @click="rightChange"></span>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'videoMonitor',
  data() {
    return {
      player:null,
      videos: [],
      currentIndex: null,
      defaultProps: {
        label: 'TypeName',
        children: null,
        isLeaf: 'leaf'
      },
      multipleShow: true,
      videoIndex: null,
      clientHeight: null,
      videoList: [],
      videoTipList: [],
      videoFull: false,
      className: 'multiple',
      playerList: [],
      scale:false,
      selectVideo: null,
      acToken: '',
      videoSrc: ''
    }
  },
  computed: {
    videoId() {
      return this.$store.state.selVideoId
    },
  },
  watch: {
    videoId(val) {
      let idx = null
      this.videos.map((n, index) => {
        if (n.id === val) {
          idx = index
        }
      })
      this.selVideo(val, idx)
    }
  },
  created() {
    this.$store.commit('closeModal', 'crafts')
    this.$store.commit('closeModal', 'dwglist')
    window.SetView('578353.5675216995,866467.136960251,15000,-26315.141263998055,-200611.8307916769,-33631.92713447177,-1.5395648300641134,-0.002660068159353768')
    window.ResetAllElement()
    window.markerArray.forEach(ele => {
      window.RemoveMarker(ele)
    })
    window.markerArray = []
    this.getTypeList()
    this.getAllVideo()
    this.getYsToken()
  },
  destroyed() {
    console.log(this.videoTipList)
    setTimeout(() => {
      for (var i = 0; i < this.videoTipList.length; i++) {
        window.RemoveMarker('videoTag' + this.videoTipList[i].cType)
      }
    }, 1000);
    window.ResetAllElement();
    window.SetView(window.R_config.initView)
  },
  methods: {
    getYsToken() {
      ApiService.tree.getYsToken().then(res => {
        console.log(res.data)
        if (res.code === 0) {
          this.acToken = JSON.parse(res.data).data.accessToken
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    getTypeList() {
      ApiService.tree.getcctvTypeData().then(res => {
        // console.log('res',res);
        if (res.code == 0) {
          this.videos = res.data
          // this.selVideo(this.videos[0], 0)
        }
      });
    },
    getAllVideo() {
      ApiService.tree.getcctvdatalist({ cType: 0, pid: 1 }).then(res => {
        if (res.code == 0) {
          this.videoTipList = res.data
          res.data.forEach(item => {
            const pos = window.GetCenterById(item.glid);
            let htmlStr = `<div class='cctv-tip' onclick='clickCCTV(${item.cType})'>
            <div class="video-img" id="cctv_${item.cType}"></div>
            <p>${item.name}</p>
            </div>`
            window.AddHtmlMarker(pos, htmlStr, 'videoTag'+item.cType)
          })
        }
      })
    },
    selVideo(val, index) {
      if (this.selectVideo) {
        document.getElementById('cctv_' + this.selectVideo.cType).className = 'video-img'
      }
      this.currentIndex = index
      // console.log(val)
      ApiService.tree.getcctvdatalist({ cType: val, pid: 0 }).then(res => {
        if (res.code == 0) {
          this.selectVideo = res.data[0]
          this.flyTO(this.selectVideo)
          this.videoSrc = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/E36254172/${index + 1}.live&autoplay=1&accessToken=${this.acToken}`
          console.log(index, this.acToken)
        }
      })
    },
    leftChange() {
      if (this.currentIndex === 0) return
      this.selVideo(this.videos[this.currentIndex - 1].id, this.currentIndex - 1)
    },
    rightChange() {
      if (this.currentIndex + 1 === this.videos.length) return
      this.selVideo(this.videos[this.currentIndex + 1].id, this.currentIndex + 1)
    },
    flyTO(item) { 
      // console.log(item)
      // window.FlyTo(item.glid, true, 2.8);
      window.elementType = 0;
      window.clickGlids = item.glid;
      window.currentElement = item.glid;
      document.getElementById('cctv_' + item.cType).className = 'video-img-sel'
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.cctv {
  position: relative;
  height: calc(100vh - 40px);
  .el-card {
    border: 0;
    background: transparent;
    border-radius: 0;

    .el-card__header {
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      background-color: $card_header;
      text-align: left;
      color: $font_color;
      border-bottom: 0;
    }

    .el-card__body {
      padding: 0;
      background: rgba(2, 16, 33, 0.6);
      width: 320px;
      // bottom: 0px;
      height: calc(100vh - 40px);
      .video-list {
        background: transparent;
        height: calc(100vh - 80px);
        overflow: auto;
        ul {
          height: 100%;
          li {
            line-height: 30px;
            height: 30px;
            padding: 0 10px;
            cursor: pointer;
            text-align: left;
            color: rgba(255, 255, 255, .85);
            &:hover {
              background: #F3B231;
              color: #fff;
            }
          }
          .active {
            background: #F3B231;
            color: #fff;
          }
        }
      }
    }
  }
  .videos {
    position: fixed;
    width: 480px;
    height: 389px;
    bottom: 32px;
    right: 32px;
    background: rgba(0, 0, 0, .5);
    .video-title {
      height: 32px;
      width: 480px;
      background: rgba(2, 16, 33, 0.6);
      color: #fff;
      display: flex;
      span {
        text-align: left;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 10px;
      }
    }
    .monitor {
      width: 100%;
      height: 357px;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
    .l-btn, .r-btn {
      position: absolute;
      display: block;
      width: 24px;
      height: 24px;
      top: 50%;
      cursor: pointer;
    }
    .l-btn {
      left: 20px;
      background: url('../../assets/huayi_img/arrow_left.png') no-repeat center;
      background-size: contain;
    }
    .r-btn {
      right: 20px;
      background: url('../../assets/huayi_img/arrow_right.png') no-repeat center;
      background-size: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/cctv.vue